class ProductsSwatches extends HTMLElement {
  constructor() {
    super();

    this.buttonsSwatches = Array.from(this.querySelectorAll('.swatch-button'));

    this.links = this.querySelectorAll('.products-swatches__content a');
    this.productTitle = this.querySelector('.products-swatches__product_title');
    this.productDescription = this.querySelector('.products-swatches__product_description');
    this.cta = this.querySelector('.products-swatches__cta');
    this.imagesLinks = this.querySelectorAll('.products-swatches__image a.image-link');
  }

  connectedCallback() {
    this.buttonsSwatches.forEach((button) => {
      button.addEventListener('click', () => {
        this.setActiveData(button);
        this.setActiveButton(button);
        this.setActiveImage(button);
      });
    });
  }

  setActiveData(button) {
    this.links.forEach((link) => {
      link.setAttribute('href', button.dataset.url);
    });
    this.productTitle.innerText = button.dataset.title;
    this.productDescription.innerText = button.dataset.description;
    this.cta.innerText = button.dataset.textCta;
  }

  setActiveButton(activeButton) {
    const btnRemoveActive = this.buttonsSwatches.find((button) => button.classList.contains('swatch-button--active'));

    btnRemoveActive.classList.remove('swatch-button--active');

    activeButton.classList.add('swatch-button--active');
  }

  setActiveImage(button) {
    this.imagesLinks.forEach((link) => {
      if (link.dataset.id === button.dataset.imageId) {
        link.classList.remove('hidden');
      } else {
        link.classList.add('hidden');
      }
    });
  }
}

customElements.define('products-swatches', ProductsSwatches);

class FaqFilter extends HTMLElement {
  constructor() {
    super();

    this.buttonsFilter = Array.from(this.querySelectorAll('.faq-filters_container button'));
    this.faqItemsContainer = this.querySelector('#accordions');
    this.faqItems = this.querySelectorAll('#accordions .accordion');

    this.buttonsFilter.forEach((button) => {
      button.addEventListener('click', () => {
        this.filterItemsByCategory(button);
      });
    });
  }

  filterItemsByCategory(button) {
    const category = button.id;

    this.faqItems.forEach((item) => {
      if (item.dataset.categoryId === category) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });

    this.setActiveButton(button);
    this.scrollToTop();
  }

  setActiveButton(activeButton) {
    const btnRemoveActive = this.buttonsFilter.find((button) => button.classList.contains('active'));

    btnRemoveActive.classList.remove('active');

    activeButton.classList.add('active');
  }

  scrollToTop() {
    this.faqItemsContainer.scrollIntoView({
      behavior: 'smooth',
    });
  }
}

customElements.define('faq-filter', FaqFilter);

class ComponentAnchor extends HTMLElement {
  constructor() {
    super();

    this.target = document.querySelectorAll(this.dataset.target)[this.dataset.targetIndex];
    this.trigger = this.querySelector('.anchor-trigger');

    this.trigger.addEventListener('click', () => {
      this.target.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });

      this.handleCollapseOpeningCase();
    });
  }

  handleCollapseOpeningCase() {
    if (this.target.classList.contains('product__accordion')) {
      this.target.querySelector('details').setAttribute('open', '');
      this.target.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('component-anchor', ComponentAnchor);
